import { useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { kidApi, errMsg } from "../lib/api";

const REASONS = [
  { id: "unkind", label: "Mean or unkind" },
  { id: "scary", label: "Scary or upsetting" },
  { id: "personal_info", label: "Shows private info" },
  { id: "inappropriate", label: "Not OK for kids" },
  { id: "spam", label: "Spam or annoying" },
  { id: "other", label: "Something else" },
];

export const ReportDialog = ({ target, onClose }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await kidApi.post("/kid/reports", { target_type: target.type, target_id: target.id, reason });
      toast.success("Thanks for telling us! Your grown-up will take a look.");
      onClose();
      setReason("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="report-dialog" className="border-[3px] border-[#1B1A2E] rounded-3xl shadow-[6px_6px_0_0_#1B1A2E] max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl flex items-center gap-2"><Flag size={20} /> Tell a grown-up</DialogTitle>
          <DialogDescription>What's wrong with this {target?.type === "creator" ? "creator" : target?.type}?</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {REASONS.map((r) => (
            <button key={r.id} data-testid={`report-reason-${r.id}`} onClick={() => setReason(r.id)}
              className={`zn-chip justify-start !rounded-2xl !py-3 ${reason === r.id ? "bg-[#FFD23F]" : "bg-white"}`}>{r.label}</button>
          ))}
        </div>
        <button data-testid="report-submit-btn" disabled={!reason || busy} onClick={send} className="zn-btn bg-[#FF6B4A] text-white w-full">Send report</button>
      </DialogContent>
    </Dialog>
  );
};
